import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchWithAuth, setToken } from "../lib/api";

const API_URL = process.env.REACT_APP_API_URL || "https://api.steelytoe.com";
const EVENT_ID = process.env.REACT_APP_EVENT_ID;

export interface LoginParams {
  uusrEmail: string;
  uusrPassword: string;
}

export function useLogin() {
  return useMutation({
    mutationFn: async ({ uusrEmail, uusrPassword }: LoginParams) => {
      const res = await fetch(`${API_URL}/api/v1/ultimate/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: { uusrEmail, uusrPassword },
        }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.message || data.error || "Login failed");
      }

      const tokenData = data.data || data;
      if (tokenData && tokenData.access_token) {
        setToken(tokenData);
      } else {
        throw new Error("Invalid token received from server");
      }
      return tokenData;
    },
  });
}

export function useUserProfile() {
  return useQuery({
    queryKey: ["userProfile"],
    queryFn: async () => {
      const res = await fetchWithAuth("/api/v1/ultimate/profile");
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.message || data.error || "Failed to fetch user profile");
      }
      return data.data || data;
    },
  });
}

export function useFetchEventHistory() {
  return useQuery({
    queryKey: ["eventHistory", EVENT_ID],
    queryFn: async () => {
      if (!EVENT_ID) {
        throw new Error("REACT_APP_EVENT_ID is not configured");
      }
      const res = await fetchWithAuth(`/api/v1/ultimate/event-history/${EVENT_ID}`);
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.message || data.error || "Failed to fetch event history");
      }
      return data;
    },
    enabled: !!EVENT_ID,
  });
}
